import { render, staticRenderFns } from "./DeleteAccountConfirmationCodeModal.vue?vue&type=template&id=d63d200e&scoped=true&lang=pug"
import script from "./DeleteAccountConfirmationCodeModal.vue?vue&type=script&lang=js"
export * from "./DeleteAccountConfirmationCodeModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccountConfirmationCodeModal.vue?vue&type=style&index=0&id=d63d200e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63d200e",
  null
  
)

export default component.exports